import h from 'virtual-dom/h'

export default class FeedbackOverlayRenderer {
    constructor(settings, feedbackPaneRenderers = [], mutators = [], childRenderers = []) {
        this._settings = settings;
        this._feedbackRenderingComponents = feedbackPaneRenderers;
        this._mutators = mutators;
        this._childRenderers = childRenderers;
    }

    initialize(store) {
        this._store = store;
    }

    getReducer() {
        return (state = {}) => {return state;};
    }

    getRenderer() {
        return () => {
            let parameters = {
                className : this._settings.classNames.feedbackOverlay,
                attributes : {
                }
            };

            var accessibility = this._settings.accessibility || {};
            var arias = accessibility.aria || {};

            if(arias.feedbackOverlay !== "REMOVE")
            {
                parameters.attributes["aria-label"] = arias.feedbackOverlay || "Feedback overlay";
            }

            let roles = accessibility.role || {};
            if(roles.feedbackOverlay !== "REMOVE")
            {
                parameters.attributes.role = roles.feedbackOverlay || "dialog";
            }
            

            this._mutators.forEach((mutate) => {
                parameters = mutate(parameters);
            });

            let childNodes = [];

            this._childRenderers.forEach((render) => {
                childNodes.push(render());
            });

            this._feedbackPaneRenderers = [];

            this._feedbackRenderingComponents.forEach((item) => {
                this._feedbackPaneRenderers.push(item.getRender());
            });
            
            let feedbackPanes = this._store.getState()
                [this._settings.stateLocations.History.Base]
                [this._settings.stateLocations.History.feedbackPanes];

            let showFeedback = this._store.getState()
                [this._settings.stateLocations.History.Base]
                [this._settings.stateLocations.History.displayFeedback];

            feedbackPanes.forEach((info) => {
                this._feedbackPaneRenderers.forEach((render) => {
                    childNodes.push(render(info));
                });
            });

            if(!parameters["attributes"]) {
                parameters["attributes"] = {};
            }

            parameters["attributes"]["data-displayed"] = showFeedback;

            return h('div', parameters, childNodes);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/renderers/overlay.js